import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { useEffect, useState } from "react";
import { useScrollLock } from "../../../hooks/useScrollLock";
import { showModal, showNestedModal } from "../../../features/modal/modalSlice";
import { handleActiveSelect } from "../../../features/layout/layoutSlice";
import FirmaTextInput from "../../shared/firmalarim/firmaInputs/FirmaTextInput";
import PageTopTitle from "../../shared/PageTopTitle";
import FirmaPhoneInput from "../../shared/firmalarim/firmaInputs/FirmaPhoneInput";
import { NumericFormat } from "react-number-format";
import { addFirmaRoutePoints, deleteFirmaRoutePoints, firmaEkle, setFirmaSelectRouteForMap, setFirmaValues, setSelectMapLatLng, updateFirstStorageInfo } from "../../../features/firma/FirmaSlice";
import Button from "../../shared/button/Btn";
import FirmaNumberInput from "../../shared/firmalarim/firmaInputs/FirmaNumberInput";
import YetkiliTextInput from "../../shared/firmalarim/yetkiliInputs/YetkiliTextInput";
import YetkiliPhoneInput from "../../shared/firmalarim/yetkiliInputs/YetkiliPhoneInput";
import RotaTextInput from "../../shared/firmalarim/rotaInputs/RotaTextInput";
import RotaIlInput from "../../shared/firmalarim/rotaInputs/RotaIlInput";
import RotaIlceInput from "../../shared/firmalarim/rotaInputs/RotaIlceInput";
import locationData from "../../../utils/locationData/locationOptions";
import iller from "../../../utils/iller";
import RotaAddressInput from "../../shared/firmalarim/rotaInputs/RotaAdresInput";
import RotaKonumInput from "../../shared/firmalarim/rotaInputs/RotaKonumInput";
import RotaPhoneInput from "../../shared/firmalarim/rotaInputs/RotaPhoneInput";
import RotaYetkiliInput from "../../shared/firmalarim/rotaInputs/RotaYetkiliInput";
import FirmaIlInput from "../../shared/firmalarim/firmaInputs/FirmaIlInput";
import FirmaIlceInput from "../../shared/firmalarim/firmaInputs/FirmaIlceInput";
import InputPhoneFormat from "../../shared/input/new/InputPhoneFormat";

const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 26;
  .modal {
    width: 600px;
    max-height: 600px;
    overflow: auto;
    color: ${({ theme }) => theme.mainTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    justify-content: space-between;
    .content {
      width: 100%;
      height: 100%;
      display: flex;
      padding: 30px;
      flex-direction: column;
      justify-content: space-between;
      .col{
        display: flex;
        flex-direction: column;
        .row{
            margin-block: 10px;
            .shortname{
              font-size: 12px;
              color: var(--color-main);
              margin-top: 5px;
            }
            .map{
              padding: 5px;
              color: var(--color-main);
              background-color: transparent;
              border-radius: 5px;
              border: 1px solid var(--color-main);
              display: inline-block;
              margin-top: 5px;
              cursor: pointer;
              font-size: var(--font-size-sm);
              height: 40px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
        }
      }
      .rota-card{
        position: relative;
        padding-top: 20px;
        padding-bottom: 10px;
        margin-bottom: 10px;
        .delete{
          position: absolute;
          top: 0;
          right: 0;
        }
      }
      .rota-title{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-lg);
            margin-bottom: 10px;
        }
      .rotalar{
        margin-block: 15px;
        .rota-ekle{
            margin-top: 15px;
            span{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-md);
                color: var(--color-main);
                padding: 5px;
                display: inline-block;
                border-radius: 5px;
                border: 1px solid var(--color-main);
                cursor: pointer;
            }
        }
        .route-btn{
          margin-block: 5px;
        }
      }
      .btn{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 15px;
        button{
            margin-inline: 15px;
        }
      }
    }
  }
  .flex{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

const FirmalarFirmaEkleModal = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  
  const { modalLocation } = useSelector((state) => state.modal);
  const { theme } = useSelector((state) => state.layout);
  const {topBarCompanyInfo} = useSelector((state)=> state.companyProfile)

  const { firmaValues, yetkiliBilgileriValues, routePoints } = useSelector((state) => state.firma);
  const {companyName, companyPhone, companyMail, companyTaxOffice, companyTaxNo,companyCityAndTown, companyAddress, companyTown, companyCity} = firmaValues
  const {officialName, officialPhone, officialMail} = yetkiliBilgileriValues
  const { lockScroll, unlockScroll } = useScrollLock();

  const [phoneValue, setPhoneValue] = useState("")

  //! bu modal açıldığnda ekran ı lock lamak için
  useEffect(() => {
    lockScroll();

    return () => {
      unlockScroll();
    };
  }, [lockScroll, unlockScroll]);

  //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
  useEffect(() => {
    if (location.pathname !== modalLocation) {
      dispatch(showModal(null));
    }
  }, [dispatch, location.pathname, modalLocation]);

  const handleAdd = () => {
    const postFirmaData = {
        firma:firmaValues,
        yetkili:yetkiliBilgileriValues,
        routePoints:routePoints
    }
    
    dispatch(firmaEkle(postFirmaData))
  }

  useEffect(() => {
    dispatch(setFirmaValues({ keyData: "companyPhone" , value: phoneValue }));
  }, [phoneValue])

  
  return (
    <Container  onClick={() => dispatch(showModal(null))}>
      <div className="modal" onClick={(e) => { e.stopPropagation(); dispatch(handleActiveSelect(null)); }}>
      <PageTopTitle isDiffPage title={"Firma Ekle"}/>
        <div className="content">
            <div onClick={(e) => { e.stopPropagation(); }} className="col">
              <div className="rota-title">Firma Bilgileri</div>
              <div className="row">
                <FirmaTextInput type="text" keyData="companyName" name="companyName" labelText="Firma Adı / Ünvanı" data={companyName} />
              </div>
              <div className="row">
                {/* <FirmaPhoneInput keyData="companyPhone" name="companyPhone" labelText="Firma Telefon No" data={companyPhone} /> */}
                <InputPhoneFormat name="companyPhone" labelText="Firma Telefon No" data={phoneValue} setData={setPhoneValue} />
              </div>
              <div className="row">
                <FirmaTextInput type="mail" keyData="companyMail" name="companyMail" labelText="Firma Mail Adresi" data={companyMail} />
              </div>
              <div className="row">
                <FirmaTextInput type="text" keyData="companyTaxOffice" name="companyTaxOffice" labelText="Vergi Dairesi" data={companyTaxOffice} />
              </div>
              <div className="row">
                <FirmaNumberInput keyData="companyTaxNo" name="companyTaxNo" labelText="Vergi Numarası" data={companyTaxNo} />
              </div>
              <div className="row">
                <FirmaIlceInput options={locationData} type="text" keyData="companyCityAndTown" name="companyCityAndTown" labelText="İl/İlçe" data={companyCityAndTown} />
              </div>
              <div className="row">
                <FirmaTextInput type="text" keyData="companyAddress" name="companyAddress" labelText="Adres" data={companyAddress} />
              </div>
            </div>

            <div className="col">
              <div className="rota-title">Yetkili Bilgileri</div>
              <div className="row">
                <YetkiliTextInput type="text" keyData="officialName" name="officialName" labelText="Yetkili Adı / Soyadı" data={officialName} />
              </div>
              <div className="row">
                <YetkiliPhoneInput keyData="officialPhone" name="officialPhone" labelText="Yetkili Telefonu" data={officialPhone} />
              </div>
              <div className="row">
                <YetkiliTextInput type="mail" keyData="officialMail" name="officialMail" labelText="Yetkili Mail Adresi" data={officialMail} />
              </div>
            </div>

            <div onClick={(e) => { e.stopPropagation(); }} className="rotalar">
              <div className="rota-title">Yükleme/Boşaltma Noktaları</div>
              {routePoints?.map((item,i)=>{
                const newIndex = i+1
                return(
                <div className="rota-card">
                  <div className="col">
                    <div className="row">
                      <RotaTextInput companyName={topBarCompanyInfo?.companyShortName} isCompanyName type="text" keyData="addressName" name={`addressName${newIndex}`} labelText="Adres Adı" data={item} />
                      {!topBarCompanyInfo?.companyShortName &&
                        <p className="shortname">Firma eklemek için profil bilgilerinizden kısa firma adı eklemelisiniz.</p>
                      }
                    </div>
                    <div className="row">
                      <RotaIlceInput options={locationData} type="text" keyData="cityAndTown" name={`cityAndTown${newIndex}`} labelText="İl/İlçe" data={item} />
                    </div>
                    <div className="row">
                      <RotaAddressInput type="text" name={`storageAddress${newIndex}`} labelText="Adres" data={item} />
                    </div>
                    <div onClick={() => {dispatch(showNestedModal("firmalarimMapModal")); dispatch(setFirmaSelectRouteForMap(item));}} className="row flex">
                      <RotaKonumInput inputWidth={"60%"} type="text" keyData="routeLocation" name={`routeLocation${newIndex}`} labelText="Konum" data={item} />
                      <span className="map">Haritadan Konum Seç</span>
                    </div>
                    {routePoints?.length < 2 &&
                      <div className="route-btn">
                        <Button handleClick={()=>dispatch(updateFirstStorageInfo({officialName:officialName, officialPhone:officialPhone}))} color="#E85446" padding="5px" height="initial">Depo Yetkilisi Firma Yetkilisi İle Aynı</Button>
                      </div>
                    }
                    <div className="row">
                      <RotaYetkiliInput type="text" name={`storageOfficialName${newIndex}`} labelText="Depo Yetkilisi Adı" data={item} />
                    </div>
                    <div className="row">
                      <RotaPhoneInput name={`storageOfficialPhone${newIndex}`} labelText="Depo Yetkilisi Telefonu" data={item} />
                    </div>
                  </div>
                  {routePoints?.length > 1 && 
                    <div className="delete">
                      <Button color="#E85446" padding="5px" height="initial" handleClick={() => dispatch(deleteFirmaRoutePoints(item.id))}>{newIndex}. Adresi Sil</Button>
                    </div> 
                  }
                </div>
              )})}
              
              <div className="rota-ekle">
                <span onClick={() => dispatch(addFirmaRoutePoints())} >Yükleme/Boşaltma Noktası Ekle</span>
              </div>
            </div>

            <div className="btn">
              <Button isDisabled={!topBarCompanyInfo?.companyShortName} width="150px" color="#E85446" padding="10px" handleClick={handleAdd}>Ekle</Button>
              <Button width="150px" color="#E85446" padding="10px" handleClick={() => dispatch(showModal(null))} >Kapat</Button>
            </div>
        </div>
      </div>
    </Container>
  );
};

export default FirmalarFirmaEkleModal;
